import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=4216d2ae&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=4216d2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4216d2ae",
  null
  
)

export default component.exports